// extracted by mini-css-extract-plugin
export default {"button":"wM70mg-QPwacsnzZ0GDnBQ==","text":"u7tMFeFwCs-sNK2eD6vBXg=="};